import Login from "./Login";

const LoginEntry = () => <Login />;

export default LoginEntry;
